import type {AjaxActionType} from 'constants/flow/flowTypes';
import type {FetchCategoryItemsResponseType} from 'reducers/category/categoryItemsType';
import {CATEGORY} from 'constants/actions';
import {categoryItemsAdapter} from './categoryItemsAdapter/categoryItemsAdapter';

const initialState = {items: [], total_items_count: 0, id: 0, status: 'initial', isAppend: false};

/**
 * Get current category data
 *
 * @param {FetchCategoryItemsResponseType} state Current state
 * @param {AjaxActionType} action Received action
 * @returns {FetchCategoryItemsResponseType} Current category data
 */
export default function categoryItems(
    state: FetchCategoryItemsResponseType = initialState,
    action: AjaxActionType,
): FetchCategoryItemsResponseType {
    let items;
    switch (action.type) {
        case `${CATEGORY.GET_CATEGORY_ITEMS}_FULFILLED`:
            items = categoryItemsAdapter(action.payload.data.items);
            return {
                ...state,
                items: action.meta.currentlyRequiredPage === 1 ? items : [...state.items, ...items],
                total_items_count: action.payload.data.total,
                status: 'fulfilled',
                isAppend: false,
            };
        case `${CATEGORY.GET_CATEGORY_ITEMS}_REJECTED`:
            return {...action.payload.response.data, status: 'rejected'};
        case `${CATEGORY.GET_CATEGORY_ITEMS}_PENDING`:
            return {
                ...state,
                status: 'pending',
                id: action.payload.id,
                isAppend: action.payload.isAppend,
            };
        case CATEGORY.CLEAR_CATEGORY_DATA:
            return initialState;
        default:
            return state;
    }
}
